import { AppUrls } from '../../../utility/appurls';
import { Component, OnInit, Output, EventEmitter, ViewChild, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { GenericLookupForm } from '../generic-lookup-form';
import { MaskConfig } from '../../../utility/mask-config';
import { MaskUtility } from '../../../utility/mask-utility';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { SelectInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/select-input/select-input.component';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { DynamicFormsService } from '../../../dynamic-forms/services/dynamic-forms/dynamic-forms.service';
import { UserInputOptionType } from 'projects/bis-shared/src/lib/shared-models/user-input-option-type';
import { FormsModule } from '@angular/forms';
import { DynamicFormLoadDirective } from '../../../dynamic-forms/directives/dynamic-form-structural.directive';
import { TextInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from '../../../dynamic-forms/dynamic-form-inputs/generic-input/generic-input.component';


@Component({
  selector: 'app-medical-supplier-lookup-form',
  templateUrl: './medical-supplier-lookup.component.html',
  styleUrls: ['./medical-supplier-lookup.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [FormsModule, DynamicFormLoadDirective , TextInputComponent, GenericInputComponent, SelectInputComponent],     
})
export class MedicalSupplierLookupFormComponent extends GenericLookupForm implements OnInit {
  private dynamicFormsService = inject(DynamicFormsService);

  @Output() enterKey: EventEmitter<any> = new EventEmitter();
  @ViewChild('medicalSupplierTypeList') medicalSupplierTypeList: SelectInputComponent;
  formLoaded = false;
  AppUrls = AppUrls;
  FieldLabelConstants = FieldLabelConstants;

  msIdMaskConfig = MaskUtility.getEntityIdMask(EntityTypeCode.MedicalSupplier);
  feinMaskConfig: MaskConfig;

  
 

  constructor() {
    super();
  }

  ngOnInit() {
    this.dynamicFormsService.getFormGroupForModel('medicalSupplierLookup').subscribe(formInfo => {
      this.formInfo = formInfo;
      this.form = formInfo.formGroup;
      this.formLoaded = true;
    });
  }

  search() {
    this.enterKey.emit();
  }

  onFeinChange() {
    this.feinMaskConfig = MaskUtility.getFEINMask();
  }

  public isValid(): boolean {
    // Valid means that some value has been entered
    return this.form && this.form.valid;
  }

  public reset(): void {
    this.form.reset({
      nameSearchOptionType: UserInputOptionType.Contains,
    });
    this.medicalSupplierTypeList.refreshOptions();
  }
}
